export { default } from './CGMInfoItem';
